(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["creator-videos-2026"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('creator-video-carousel')) {
    class CreatorVideoCarousel extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-creator-videos-track]');
        this.previousButton = this.querySelector('[data-creator-videos-previous]');
        this.nextButton = this.querySelector('[data-creator-videos-next]');
        this.dialog = this.querySelector('[data-creator-video-dialog]');
        this.player = this.querySelector('[data-creator-video-player]');
        this.dialogTitle = this.querySelector('[data-creator-video-title]');
        this.abortController = new AbortController();
        const signal = this.abortController.signal;

        this.previousButton?.addEventListener('click', () => this.scroll(-1), { signal });
        this.nextButton?.addEventListener('click', () => this.scroll(1), { signal });
        this.track?.addEventListener('scroll', () => this.updateNavigation(), { passive: true, signal });
        this.querySelectorAll('[data-creator-video-open]').forEach((button) => {
          button.addEventListener('click', () => this.openVideo(button), { signal });
        });
        this.querySelectorAll('[data-creator-video-close]').forEach((button) => {
          button.addEventListener('click', () => this.dialog?.close(), { signal });
        });
        this.dialog?.addEventListener('close', () => this.clearPlayer(), { signal });

        this.resizeObserver = new ResizeObserver(() => this.updateNavigation());
        if (this.track) this.resizeObserver.observe(this.track);
        this.updateNavigation();
      }

      disconnectedCallback() {
        this.abortController?.abort();
        this.resizeObserver?.disconnect();
        this.clearPlayer();
      }

      scroll(direction) {
        const card = this.track?.querySelector('.creator-videos__card');
        if (!card) return;
        const styles = getComputedStyle(this.track);
        const gap = Number.parseFloat(styles.columnGap || styles.gap) || 0;
        const rtlMultiplier = styles.direction === 'rtl' ? -1 : 1;
        this.track.scrollBy({ left: direction * rtlMultiplier * (card.offsetWidth + gap), behavior: 'smooth' });
      }

      updateNavigation() {
        if (!this.track) return;
        const maxScroll = this.track.scrollWidth - this.track.clientWidth;
        const currentScroll = Math.abs(this.track.scrollLeft);
        if (this.previousButton) this.previousButton.disabled = currentScroll <= 1;
        if (this.nextButton) this.nextButton.disabled = currentScroll >= maxScroll - 1;
      }

      openVideo(button) {
        const embedUrl = this.buildEmbedUrl(button.dataset.videoUrl || '');
        if (!embedUrl || !this.dialog || !this.player) return;

        const title = button.dataset.videoTitle || '';
        const iframe = document.createElement('iframe');
        const poster = button.querySelector('.creator-videos__cover')?.cloneNode(true);
        const spinner = document.createElement('span');

        iframe.src = embedUrl;
        iframe.title = title;
        iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
        iframe.allowFullscreen = true;
        iframe.referrerPolicy = 'strict-origin-when-cross-origin';
        iframe.addEventListener('load', () => this.player?.classList.add('is-loaded'), { once: true });
        if (poster) poster.setAttribute('class', 'creator-video-dialog__poster');
        spinner.className = 'creator-video-dialog__spinner';
        spinner.setAttribute('aria-hidden', 'true');

        this.dialogTitle.textContent = title;
        this.player.classList.remove('is-loaded');
        this.player.replaceChildren(...(poster ? [poster, spinner, iframe] : [spinner, iframe]));
        this.dialog.showModal();
      }

      buildEmbedUrl(sourceUrl) {
        try {
          const url = new URL(sourceUrl);
          const host = url.hostname.replace(/^www\./, '');
          let videoId = '';

          if (host === 'youtu.be') {
            videoId = url.pathname.split('/').filter(Boolean)[0] || '';
          } else if (host === 'youtube.com' || host === 'm.youtube.com') {
            const segments = url.pathname.split('/').filter(Boolean);
            if (url.pathname === '/watch') {
              videoId = url.searchParams.get('v') || '';
            } else if (['embed', 'shorts', 'live'].includes(segments[0])) {
              videoId = segments[1] || '';
            }
          }

          if (!/^[A-Za-z0-9_-]{11}$/.test(videoId)) return '';
          const params = new URLSearchParams({ autoplay: '1', rel: '0' });
          const start = this.parseStartTime(url.searchParams.get('t') || url.searchParams.get('start') || '');
          if (start > 0) params.set('start', String(start));
          return `https://www.youtube-nocookie.com/embed/${encodeURIComponent(videoId)}?${params}`;
        } catch (error) {
          return '';
        }
      }

      parseStartTime(value) {
        if (/^\d+$/.test(value)) return Number.parseInt(value, 10);
        const match = value.match(/^(?:(\d+)h)?(?:(\d+)m)?(?:(\d+)s?)?$/);
        if (!match) return 0;
        return Number(match[1] || 0) * 3600 + Number(match[2] || 0) * 60 + Number(match[3] || 0);
      }

      clearPlayer() {
        this.player?.classList.remove('is-loaded');
        this.player?.replaceChildren();
      }
    }

    customElements.define('creator-video-carousel', CreatorVideoCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["youtube-live-floating"] && !Shopify.designMode) return;
  try {
    
  class YoutubeLiveFloating {
    constructor(container) {
      this.container = container;
      this.iframe = container.querySelector('.youtube-live-floating__iframe');
      this.panel = container.querySelector('.youtube-live-floating__panel');
      this.openButton = container.querySelector('[data-youtube-live-open]');
      this.closeButton = container.querySelector('[data-youtube-live-close]');
      this.embedUrl = this.buildEmbedUrl(container.dataset.youtubeUrl);
      this.startAt = this.parseTimestamp(container.dataset.startAt);
      this.endAt = this.parseTimestamp(container.dataset.endAt);
      this.timerId = null;
      this.isDismissed = false;

      if (!this.embedUrl || this.startAt === null || this.endAt === null || this.startAt >= this.endAt) {
        return;
      }

      this.bindEvents();
      this.updateVisibility();
    }

    bindEvents() {
      this.closeButton.addEventListener('click', () => this.close());
      this.openButton.addEventListener('click', () => this.open());
    }

    parseTimestamp(value) {
      const timestamp = Date.parse(value || '');
      return Number.isNaN(timestamp) ? null : timestamp;
    }

    updateVisibility() {
      const now = Date.now();

      if (now < this.startAt) {
        this.hide();
        this.scheduleUpdate(this.startAt);
        return;
      }

      if (now >= this.endAt) {
        this.hide();
        return;
      }

      this.container.hidden = false;
      this.loadIframe();
      this.panel.hidden = this.isDismissed;
      this.openButton.hidden = !this.isDismissed;
      this.scheduleUpdate(this.endAt);
    }

    scheduleUpdate(targetTime) {
      const oneHour = 60 * 60 * 1000;
      const delay = Math.min(Math.max(targetTime - Date.now(), 0), oneHour);

      window.clearTimeout(this.timerId);
      this.timerId = window.setTimeout(() => this.updateVisibility(), delay);
    }

    loadIframe() {
      if (!this.iframe.hasAttribute('src')) {
        this.iframe.src = this.embedUrl;
      }
    }

    unloadIframe() {
      this.iframe.removeAttribute('src');
    }

    hide() {
      this.container.hidden = true;
      this.panel.hidden = true;
      this.openButton.hidden = true;
      this.unloadIframe();
    }

    buildEmbedUrl(sourceUrl) {
      const videoId = this.getVideoId(sourceUrl);

      if (!videoId) {
        return '';
      }

      const url = new URL(videoId.startsWith('https://') ? videoId : `https://www.youtube.com/embed/${videoId}`);
      url.searchParams.set('autoplay', '1');
      url.searchParams.set('mute', '1');
      url.searchParams.set('playsinline', '1');
      url.searchParams.set('rel', '0');

      return url.toString();
    }

    getVideoId(sourceUrl) {
      try {
        const url = new URL(sourceUrl);
        const host = url.hostname.replace(/^www\./, '');

        if (host === 'youtube.com' || host === 'm.youtube.com') {
          if (url.pathname.startsWith('/embed/')) {
            return url.toString();
          }

          if (url.searchParams.get('v')) {
            return this.cleanId(url.searchParams.get('v'));
          }

          const liveMatch = url.pathname.match(/^\/live\/([^/?]+)/);
          if (liveMatch && liveMatch[1]) {
            return this.cleanId(liveMatch[1]);
          }
        }

        if (host === 'youtu.be') {
          return this.cleanId(url.pathname.split('/').filter(Boolean)[0]);
        }
      } catch (error) {
        return '';
      }

      return '';
    }

    cleanId(value) {
      const id = String(value || '').trim().match(/^[a-zA-Z0-9_-]{6,}$/);
      return id ? id[0] : '';
    }

    open() {
      if (Date.now() < this.startAt || Date.now() >= this.endAt) {
        this.updateVisibility();
        return;
      }

      this.isDismissed = false;
      this.panel.hidden = false;
      this.openButton.hidden = true;
    }

    close() {
      if (Date.now() < this.startAt || Date.now() >= this.endAt) {
        this.updateVisibility();
        return;
      }

      this.isDismissed = true;
      this.panel.hidden = true;
      this.openButton.hidden = false;
    }
  }

  document.querySelectorAll('.youtube-live-floating[data-youtube-url]').forEach((container) => {
    new YoutubeLiveFloating(container);
  });

  } catch(e) { console.error(e); }
})();
})();
